import { observable, makeObservable } from 'mobx';
import { ModalParams } from 'core/models';
import { isSome } from 'core/utils';

class ConfirmModalParams extends ModalParams {
	@observable message = null;
	@observable yesLabel = 'Yes';
	@observable noLabel = 'No';

	constructor(opts) {
		super(opts);
		makeObservable(this);
		this.onConfirm = async () => {
			if (opts && opts.onConfirm) {
				await Promise.resolve(opts.onConfirm(this.data));
			}
			this.close();
		};

		this.onCancel = (opts && opts.onCancel) || this.close;
		if (isSome(opts.yesLabel)) {
			this.yesLabel = opts.yesLabel;
		}
		if (isSome(opts.noLabel)) {
			this.noLabel = opts.noLabel;
		}
	}
	open({ message }, data = null) {
		if (data != null) {
			this.data = data;
		}
		this.message = message;
		this.setOpen(true);
	}
}

export default ConfirmModalParams;



// WEBPACK FOOTER //
// ./src/core/models/ConfirmModalParams.js